import { useCallback, useEffect, useMemo, useState } from 'react'
import { useProjectPlanSnapshotRepository } from '../../../../../../../services/adaptors/projectPlanSnapshotRepositoryAdaptor'
import { ProjectPlanSelectRow } from '../model'

type UseProjectPlanSelectDataProps = {
  snapshotUuid: string
  selectedUuids: string[]
}

export const useProjectPlanSelectData = ({
  snapshotUuid,
  selectedUuids,
}: UseProjectPlanSelectDataProps) => {
  const [partialRows, setPartialRows] = useState<
    Omit<ProjectPlanSelectRow, 'selected'>[]
  >([])

  const { fetchMasterSchedule } = useProjectPlanSnapshotRepository()

  const fetchSnapshotData = useCallback(
    async (uuid: string) => {
      const response = await fetchMasterSchedule(uuid)
      return response.map(resp => ({
        uuid: resp.uuid,
        treeValue: resp.path,
        displayName: resp.wbsItem.displayName,
        type: resp.type,
      }))
    },
    [fetchMasterSchedule]
  )

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetchSnapshotData(snapshotUuid)
        setPartialRows(result)
      } catch (error) {
        console.error('Failed to fetch project plan data:', error)
        setPartialRows([])
      }
    }

    fetchData()
  }, [snapshotUuid, fetchSnapshotData])

  const rows = useMemo(() => {
    const selectedSet = new Set(selectedUuids)
    return partialRows.map(r => {
      const selected = selectedSet.has(r.uuid)
      return {
        ...r,
        selected,
      } as ProjectPlanSelectRow
    })
  }, [partialRows, selectedUuids])

  return { rows }
}
